import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useMemo, useCallback } from 'react';
import { styled } from '@mui/material/styles';
import 'regenerator-runtime/runtime';
import { useAsyncDebounce } from 'react-table';
import Dropdown from '../../../../Dropdown/Dropdown.js';
import '../../../../BaseDropdown/BaseDropdown.js';
import '../../../../BaseDropdown/types.js';
import '../../../../BaseDropdown/components/VirtualizedMenuList.js';
import '../../../../Dropdown/components/OptionItem.js';
import '../../../../Dropdown/components/Menu.js';
import 'tslib';
import '../../../../Dropdown/context/DropdownProvider.js';
import 'react-select';
import { numberFilters, stringFilters } from '../../../utils/filters/index.js';
import { FilterPopover } from '../common/FilterPopover.js';
import InputField from '../common/InputField.js';

const _Dropdown = styled(Dropdown) `
  width: 100%;
  margin: ${({ theme }) => theme.spacing(1)};
`;
const InputFilter = ({ options, type, placeholder, column, rtl }) => {
    const [filterType, setFilterType] = useState(options[0]);
    const [inputValue, setInputValue] = useState(column.filterValue || '');
    const filters = useMemo(() => (type === 'number' ? numberFilters : stringFilters), [type]);
    const onChange = useAsyncDebounce((value) => {
        const filter = filters[filterType.value];
        column.setFilter(!value ? undefined : { value, filter, filterType });
        setInputValue(value);
    }, 200);
    const onOptionSelect = useCallback((data) => {
        if (data) {
            const filter = filters[data.value];
            column.setFilter({ value: inputValue, filter, filterType });
            setFilterType(data);
        }
    }, [column, filterType, filters, inputValue]);
    return (jsxs(FilterPopover, Object.assign({ rtl: rtl }, { children: [jsx(_Dropdown, { "data-testid": "filter-options", value: filterType, noOptionsMessage: "", onChange: onOptionSelect, options: options }), jsx(InputField, { onChange: onChange, type: type, placeholder: placeholder, value: inputValue })] })));
};

export { InputFilter as default };
//# sourceMappingURL=InputFilter.js.map
